<template>
  <div>
    <section-title
      container-class="tag-badge-main-info my-4"
      content="I. Completar Cita"
      icon="fas fa-clipboard-list-check"
    />
    <validation-observer ref="form" novalidate>
      <div class="bg-secondary-11 p-4 rounded my-3">
        <div class="data-name">
          ¿La cita fue completada en el mismo municipio, localización,
          especialista, día y hora?
        </div>
        <div>
          <validation-provider
            v-if="!isReadOnly"
            ref="isCompletedOtherLocation"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-radio
              v-model="model.isCompletedOtherLocation"
              class="mt-1 ml-n3"
              custom-error-msg="Favor contestar Sí o No."
              :disabled="isReadOnly"
              :error="errors[0]"
              is-inline
              name="isCompletedOtherLocation"
              :options="yesNoOptions"
              @input="onChangeIsCompletedOtherLocation"
            />
          </validation-provider>
          <div v-else>
            {{ model.isCompletedOtherLocation | boolText }}
          </div>
        </div>

        <div class="row my-3">
          <div class="col-md-4 border-right">
            <div>
              <div class="data-name">
                Proveedor
              </div>
              <div>
                {{ model.companyName | empty }}
              </div>
            </div>
            <div class="my-3">
              <div class="data-name">
                Dirección:
              </div>
              <div>
                {{ locationAddress | empty }}
              </div>
            </div>
          </div>
          <div class="col-md px-5">
            <div>
              <div class="data-name">
                Fecha:
              </div>
              <validation-provider
                v-if="model.isCompletedOtherLocation == false && !isReadOnly"
                ref="appointmentDate"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-date-picker
                  v-model="model.appointmentDate"
                  class="w-100"
                  custom-error-msg="El campo es requerido."
                  :error="errors[0]"
                  :max-date="new Date()"
                  placeholder="DD/MM/YYYY"
                />
              </validation-provider>
              <div v-else>
                {{ model.appointmentDate | date }}
              </div>
            </div>
            <div class="my-3">
              <div class="data-name">
                Municipio:
              </div>
              <validation-provider
                v-if="model.isCompletedOtherLocation == false && !isReadOnly"
                ref="municipality"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="model.municipality"
                  custom-error-msg="El campo es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.municipalities"
                  placeholder="Seleccione"
                  @input="onChangeMunicipality"
                />
              </validation-provider>
              <div v-else>
                {{ model.locationAddressMunicipalityName | empty }}
              </div>
            </div>
            <div class="row my-4">
              <div class="col-12 col-md-6">
                <div class="data-name">
                  Localización:
                </div>
                <validation-provider
                  v-if="model.isCompletedOtherLocation == false && !isReadOnly"
                  ref="location"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.location"
                    custom-error-msg="El campo es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="catalog.locations"
                    placeholder="Seleccione"
                    @input="onChangeLocation"
                  />
                </validation-provider>
                <div v-else>
                  {{ model.locationTypeName }} - {{ model.locationName }}
                </div>
              </div>
              <div class="col-1 col-md-6">
                <div class="data-name">
                  Especialista:
                </div>

                <validation-provider
                  v-if="model.isCompletedOtherLocation == false && !isReadOnly"
                  ref="specialist"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.specialist"
                    custom-error-msg="El campo es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="catalog.specialists"
                    placeholder="Seleccione"
                    @input="onChangeSpecialist"
                  />
                </validation-provider>
                <div v-else>
                  {{ model.specialistFullname | empty }}
                </div>
              </div>
            </div>
            <div class="row my-4">
              <div class="col-12 col-md-4">
                <div class="data-name">
                  Hora Desde:
                </div>
                <validation-provider
                  v-if="model.isCompletedOtherLocation == false && !isReadOnly"
                  ref="timeStart"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-time-picker
                    v-model="model.timeStart"
                    custom-error-msg="El campo es requerido."
                    :error="errors[0]"
                    @input="onChangeTimeStart"
                  />
                </validation-provider>
                <div v-else>
                  {{ model.timeStart | hour }}
                </div>
              </div>
              <div
                class="col-12 col-md"
                :class="{ 'pt-1': model.isCompletedOtherLocation === false }"
              >
                <div class="data-name">
                  Hora Hasta:
                </div>
                <validation-provider
                  v-if="model.isCompletedOtherLocation == false && !isReadOnly"
                  ref="timeEnd"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-time-picker
                    v-model="model.timeEnd"
                    custom-error-msg="El campo es requerido."
                    :error="errors[0]"
                  />
                </validation-provider>
                <div v-else>
                  {{ model.timeEnd | hour }}
                </div>
                <error
                  v-if="validations.invalidDate"
                  :message="validations.invalidDate"
                  variant="no-border mt-1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <validation-provider
          v-if="model.hasSignLanguageInterpreterInContract"
          ref="hasSignLanguageInterpreter"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-radio
            v-model="model.hasSignLanguageInterpreter"
            class="mt-4 mb-2"
            custom-error-msg="El campo es requerido."
            :disabled="isReadOnly"
            :error="errors[0]"
            is-inline
            label="¿La evaluación tuvo asistencia de intérprete de lenguaje de señas?"
            name="hasSignLanguageInterpreter"
            :options="yesNoOptions"
          />
        </validation-provider>
        <div class="row">
          <div class="col-md-8">
            <div class="data-name">
              ¿La evaluación fue realizada por un Interno/Practicante?
            </div>
            <validation-provider
              v-if="!isReadOnly"
              ref="appointmentHasPractitioner"
              v-slot="{ errors }"
              rules="required"
            >
              <custom-radio
                v-model="model.appointmentHasPractitioner"
                class="mt-4 mb-2"
                custom-error-msg="Favor contestar Sí o No."
                :disabled="isReadOnly"
                :error="errors[0]"
                is-inline
                name="appointmentHasPractitioner"
                :options="yesNoOptions"
                @input="onChangePractitioner"
              />
            </validation-provider>
            <div v-else>
              {{ model.appointmentHasPractitioner | boolText }}
            </div>
          </div>
        </div>
        <div v-if="model.appointmentHasPractitioner" class="mt-2">
          <div class="data-name">
            Interno/Practicante:
          </div>
          <validation-provider
            v-if="catalog.practitioners.length > 0"
            ref="practitioner"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-drop-down
              v-model="model.practitioner"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="catalog.practitioners"
              placeholder="seleccione"
            />
          </validation-provider>
          <error
            v-else
            message="El Especialista seleccionado no tiene relacionado Practicante/Interno a su licencia y Lugar de Servicio. (R80556)"
          />
        </div>
        <div>
          <validation-provider
            v-if="showHasEducationalEvaluation"
            ref="hasEducationalEvaluation"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-radio
              v-model="model.hasEducationalEvaluation"
              class="mt-4 mb-2"
              custom-error-msg="Favor contestar Sí o No."
              :disabled="isReadOnly"
              :error="errors[0]"
              is-inline
              label="¿La evaluación realizada fue Educativa?"
              name="hasEducationalEvaluation"
              :options="yesNoOptions"
            />
          </validation-provider>
        </div>
        <div>
          <div class="data-name">
            Requiere reevaluación a partir de la implementación de las
            recomendaciones ofrecidas en este informe de evaluación.
          </div>
          <validation-provider
            v-if="!isReadOnly"
            ref="hasRecommendedReevaluation"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-radio
              v-model="model.hasRecommendedReevaluation"
              class="mt-4 mb-2"
              custom-error-msg="Favor contestar Sí o No."
              :disabled="isReadOnly"
              :error="errors[0]"
              is-inline
              name="hasRecommendedReevaluation"
              :options="yesNoOptions"
              @input="onChangeHasRecommendedReevaluation"
            />
          </validation-provider>
          <div v-else>
            {{ model.hasRecommendedReevaluation | boolText }}
          </div>
        </div>
        <div
          v-if="model.hasRecommendedReevaluation"
          class="bg-secondary-11 p-3 rounded mt-3"
        >
          <div class="row">
            <div class="col-lg-3 col-md-3">
              <validation-provider
                ref="reevaluationTime"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="model.reevaluationTime"
                  :clearable="!isReadOnly"
                  custom-error-msg="El campo es es requerido."
                  :disabled="isReadOnly"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Tiempo para reevaluación:"
                  :options="catalog.reevaluationTimes"
                  placeholder="Seleccione"
                  @input="onChangeReevaluationTime"
                />
              </validation-provider>
            </div>

            <div class="col-md-12 pt-2">
              <validation-provider
                ref="recommendedReevaluationComment"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-text-area
                  v-model="model.recommendedReevaluationComment"
                  custom-error-msg="El campo es requerido."
                  :disabled="isReadOnly"
                  :error="errors[0]"
                  label="¿Con qué finalidad?"
                  :maxlength="3000"
                  show-char-count
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div :class="isReadOnly ? 'mt-3' : ''">
          <validation-provider
            ref="statusComment"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-text-area
              v-if="!isReadOnly"
              v-model="model.statusComment"
              class="mt-4 mb-2"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              :error="errors[0]"
              label="Impresión Diagnóstica:"
              :maxlength="2000"
            />
            <div v-else class="d-flex flex-column">
              <label class="text-muted" style="font-size: 14px">
                Impresión Diagnóstica:
              </label>
              <span>{{ model.statusComment }}</span>
            </div>
          </validation-provider>
        </div>
        <div v-if="canAddDiagnosisInPilot" class="my-3">
          <custom-todo
            v-model="model.diagnostics"
            :draggable="!isReadOnly"
            has-chip
            has-pagination
            is-drop-down
            :is-read-only="isReadOnly"
            label="¿Cuál es el diagnóstico del estudiante?"
            :options="diagnosticsOptions"
            separator="Diagnósticos añadidos"
          />
          <validation-provider
            v-slot="{ errors }"
            name="diagnostics"
            :rules="model.hasCpt ? 'required' : ''"
          >
            <error
              v-if="errors[0]"
              class="pt-2"
              message="Al menos un Diagnóstico es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="mt-4">
      <section-title has-line title="Recomendación de Intervención" />
    </div>
    <div class="row">
      <div class="col-md-4 border-right">
        <div class="data-name">
          ¿Recomienda Intervención?
        </div>
        <validation-provider
          v-if="!isReadOnly"
          ref="appointmentTherapyFlag"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-radio
            v-model="model.appointmentTherapyFlag"
            class="mt-2 mb-2"
            custom-error-msg="Favor contestar Sí o No."
            :error="errors[0]"
            is-inline
            name="appointmentTherapyFlag"
            :options="yesNoOptions"
          />
        </validation-provider>
        <div v-else>
          {{ model.appointmentTherapyFlag | boolText }}
        </div>
      </div>
      <div
        v-if="model.appointmentTherapyFlag && showIntervationRecommendation"
        class="col-md-8"
      >
        <intervention-recomendation
          :id="appointmentId"
          :catalog-interventions="catalog.intervations"
          :durations="catalog.durations"
          :frequencies="catalog.frequencies"
          :get-appointment-therpies="getTherpies"
          :is-read-only="isReadOnly"
          :modalities="catalog.modalities"
          :show-durations="showFields.durations"
          :show-frequency="showFields.frequencies"
          :show-intervation="showFields.intervations"
          :show-modalities="showFields.modalities"
          @on-change-therapies="model.therapies = $event"
          @on-change-therapy-flag="model.appointmentTherapyFlag = $event"
        />
        <error
          v-if="showTherapiesError"
          message="Debe agregar al menos una Recomendación de Intervención"
          variant="no-border mt-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//utils
import moment from 'moment';
import { copy } from '@/utils/objUtils';
import DisciplineCategories from '@/utils/constants/disciplineCategories';
import DisciplineTypes from '@/utils/constants/disciplineTypeCode';
import ServiceTypes from '@/utils/constants/serviceTypes';

//filters

//components
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import SectionTitle from '@/shared/components/SectionTitle.vue';
import CustomDropDown from 'custom-drop-down';
import Error from 'custom-error';
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import CustomTimePicker from '@/components/common/CustomTimePicker.vue';
import CustomRadio from '@/components/common/CustomRadio';
import CustomTodo from '@/components/common/CustomTodo.vue';

//local-components
import InterventionRecomendation from './components/InterventionRecomendation';

//services
import { getAppointment as get } from '@/modules/vocational-evaluation/api.js';
import {
  getSpecialistPractitioners as getPractitioners,
  getAppointmentLocations as getLocations,
  getSpecialistByLocation as getSpecialistsByLocation,
  getAppointmentTherpies as getTherpies,
  getTherapyServices as getServices,
} from '@/modules/provider/api';
import {
  getReevaluationTimes,
  getTherapyDurations as getDurations,
  getServiceModalities as getModalities,
  getFrequencyType as getFrequencies,
  getStudentDiagnostics as getDiagnostics,
} from '@/modules/shared/code.api.js';
import { getMunicipalities } from '@/modules/shared/providerappointment.api';
import { getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';

//constants
const ShowHasEducationalEvaluationOptions = Object.freeze({
  companyId: 364, // Centro de Diagnóstico para Inteligencias Múltiples
  // Psicoeducativa
  disciplineTypes: [
    682, // en Terapia
    689, // en Evaluación Adicional
    1754,
  ], // en Evaluación Inicial
});

export default {
  name: 'VocationalEducationAppointment',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    CustomTimePicker,
    CustomTextArea,
    SectionTitle,
    Error,
    CustomDatePicker,
    CustomRadio,
    InterventionRecomendation,
    CustomTodo,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    appointmentId: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    initialModel: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    keepUpdates: {
      type: Boolean,
      required: false,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      showHasEducationalEvaluation: false,
      showIntervationRecommendation: false,
      catalog: {
        locations: [],
        municipalities: [],
        specialists: [],
        practitioners: [],
        intervations: [],
        frequencies: [],
        modalities: [],
        durations: [],
        reevaluationTimes: [],
        diagnostics: [],
      },
      validations: {
        invalidDate: null,
        interventionRequired: null,
      },
      showFields: {
        frequencies: true,
        modalities: true,
        durations: true,
        intervations: true,
      },
      canAddDiagnosis: false,
      medicaidPilotCompanyIds: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    yesNoOptions() {
      return [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ];
    },
    locationAddress() {
      let value = this.model.locationAddressLine1;
      if (this.model.locationAddressLine2?.trim())
        value = `${value} ${this.model.locationAddressLine2}`;

      if (this.model.locationAddressLine3?.trim())
        value = `${value} ${this.model.locationAddressLine3}`;
      return value;
    },
    getTherpies() {
      return getTherpies;
    },
    isValidPractitioner() {
      return (
        !this.model.appointmentHasPractitioner ||
        this.model.practitioner?.id > 0
      );
    },
    filled() {
      return this.initialModel?.filled ?? false;
    },
    showTherapiesError() {
      return (
        !!this.$refs.appointmentTherapyFlag?.flags.valid &&
        !!this.$refs.appointmentTherapyFlag?.flags.validated &&
        this.model.appointmentTherapyFlag &&
        !this.model.therapies?.length
      );
    },
    diagnosticsOptions() {
      return this.catalog.diagnostics.filter(
        (x) => !this.model.diagnostics.map((d) => d.id).includes(x.id)
      );
    },
    canAddDiagnosisInPilot() {
      return (
        this.canAddDiagnosis &&
        this.medicaidPilotCompanyIds.some((x) => x === this.model.companyId)
      );
    },
  },
  async mounted() {
    this.$emit('update:disabled', true);
    await this.init();
    this.setModelFrom(this.model);
    this.$emit('update:disabled', false);
  },
  beforeDestroy() {
    this.$emit('update:initialModel', this.model);
  },
  methods: {
    async init() {
      await Promise.all([this.getSysParams(), this.get()]);
      this.setShowHasEducationalEvaluation();
      await Promise.all([
        this.onChangeIsCompletedOtherLocation(
          this.model.isCompletedOtherLocation
        ),
        this.onChangeTherapy(true),
        this.getDiagnostics(),
      ]);
    },
    setModelFrom(value) {
      const data = copy(value);
      data.timeStart = moment(data.timeStart).toDate();
      data.timeEnd = moment(data.timeEnd).toDate();
      this.model = data;
      this.$emit('update:initialModel', data);
    },
    async get() {
      if (this.keepUpdates && this.filled) {
        this.setModelFrom(this.initialModel);
        return;
      }

      if (!this.appointmentId) return;
      const { data: res } = await get({
        id: this.id,
        appointmentId: this.appointmentId,
      });
      if (!res) return;
      const appointment = res.appointment;
      delete res.appointment;
      const data = { ...appointment, ...res };
      this.model = {
        ...data,
        filled: true,
        appointmentDate: data.timeStart,
        timeStart: moment(data.timeStart).toDate(),
        timeEnd: moment(data.timeEnd).toDate(),
        location: {
          id: data.locationFiscalYearId,
          name: data.locationName,
        },
        municipality: {
          id: data.locationMunicipalityId,
          name: data.locationMunicipalityName,
        },
        specialist: {
          id: data.specialistLocationId,
          name: data.specialistFullname,
        },
        therapies: [],
        diagnostics: data.diagnostics ?? [],
      };
      await this.onChangeHasRecommendedReevaluation(
        this.model.hasRecommendedReevaluation
      );
    },
    async validate() {
      const valid = await this.$refs.form.validate();
      const appointmentTherapyFlag = await this.$refs.appointmentTherapyFlag.validate();
      return valid && appointmentTherapyFlag.valid && !this.showTherapiesError;
    },
    async getPractitioners() {
      const { data } = await getPractitioners(
        this.model.disciplineTypeCod,
        this.model.specialist?.id
      );
      this.catalog.practitioners = data;
    },
    async getMunicipalities(locationId) {
      const {
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
      } = this.model;
      const { data } = await getMunicipalities(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationId
      );
      this.catalog.municipalities = data;
    },
    async getSpecialistsByLocation(locationFiscalYearId) {
      const {
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
      } = this.model;
      const { data } = await getSpecialistsByLocation(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationFiscalYearId
      );
      this.catalog.specialists = data;
    },
    async getLocations(locationAddressMunicipalityId) {
      const {
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
      } = this.model;
      const { data } = await getLocations(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationAddressMunicipalityId
      );
      this.catalog.locations = data;
    },
    async getIntervations() {
      const categories = [DisciplineCategories.ValidForEncuentro];
      if (this.model.disciplineTypeCod == DisciplineTypes.EvaluacionVocacional)
        categories.push(DisciplineCategories.VocationalEvaluation);
      const { data } = await getServices([ServiceTypes.Therapy], categories);
      this.catalog.intervations = data;
    },
    async getModalities() {
      const param =
        this.model.disciplineTypeCod == DisciplineTypes.EducacionFisicaAdaptada
          ? this.model.disciplineTypeCod
          : null;
      const { data } = await getModalities(param);
      this.catalog.modalities = data;
    },
    async getDurations() {
      const { data } = await getDurations();
      this.catalog.durations = data;
    },
    async getFrequencies() {
      const { data } = await getFrequencies();
      this.catalog.frequencies = data;
    },
    async getDiagnostics() {
      if (!this.canAddDiagnosisInPilot) return;
      const { data } = await getDiagnostics(this.model.disciplineTypeCod);
      this.catalog.diagnostics = data;
    },
    async getSysParams() {
      const { data } = await getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.CanAddDiagnosis,
          sysparameterByNames.MedicaidPilotCompanyIds,
        ],
      });

      this.canAddDiagnosis =
        data
          ?.find((x) => x.name == 'CanAddDiagnosis')
          ?.staticValue?.toLowerCase() == 'true' ?? false;

      this.medicaidPilotCompanyIds =
        data
          ?.find((x) => x.name === 'MedicaidPilotCompanyIds')
          ?.staticValue?.split(',')
          .map((x) => parseInt(x, 10)) ?? [];
    },
    async onChangeSpecialist(value) {
      this.model.practitioner = null;
      if (value) await this.getPractitioners();
      else this.catalog.practitioners = [];
    },
    async onChangeIsCompletedOtherLocation(value) {
      if (!value) {
        await this.getMunicipalities(0);
        await this.getLocations(this.model.municipality?.id);
        await this.getSpecialistsByLocation(this.model.locationFiscalYearId);
      } else {
        this.model.appointmentDate = this.model.timeStart;
        this.model.timeStart = moment(this.model.timeStart).toDate();
        this.model.timeEnd = moment(this.model.timeEnd).toDate();
      }
    },
    async onChangePractitioner(value) {
      if (value) await this.getPractitioners();
      else this.model.practitioner = null;
    },
    async onChangeLocation(value) {
      if (value?.id) await this.getLocations(value.id);
      else this.catalog.specialists = [];
      this.model.specialist = null;
    },
    async onChangeMunicipality(value) {
      if (value?.id) await this.callGetLocations(value?.id);
      else {
        this.catalog.locations = [];
        this.catalog.specialists = [];
      }
      this.model.location = null;
      this.model.specialist = null;
    },
    async onChangeHasRecommendedReevaluation(value) {
      this.model.reevaluationTime = null;
      if (!value || this.catalog.reevaluationTimes.length) return;
      const { data } = await getReevaluationTimes();
      this.catalog.reevaluationTimes = data.filter((x) => !x.isDisabledTime);
    },
    async onChangeTherapy(value) {
      if (!value) return;
      const areEmpty = [
        !this.catalog.intervations.length,
        !this.catalog.frequencies.length,
        !this.catalog.durations.length,
        !this.catalog.modalities.length,
      ].includes(true);
      if (!areEmpty) return;
      const requests = [];
      if (this.showFields.intervations) requests.push(this.getIntervations());
      if (this.showFields.modalities) requests.push(this.getModalities());
      if (this.showFields.durations) requests.push(this.getDurations());
      if (this.showFields.frequencies) requests.push(this.getFrequencies());
      await Promise.all(requests);
      this.showIntervationRecommendation = Boolean(requests.length);
    },
    onChangeReevaluationTime(value) {
      if (!value?.id) return;
      this.model.recommendedReevaluationTime = value.unitOfTime;
      this.model.recommendedReevaluationPeriod = value.reevaluationPeriodId;
    },
    onChangeTimeStart(value) {
      if (!value) return;
      this.model.timeEnd = moment(value, 'HH:mm')
        .add(this.model.minuteDuration, 'minutes')
        .toDate();
    },
    setShowHasEducationalEvaluation() {
      const {
        companyId,
        disciplineTypes,
      } = ShowHasEducationalEvaluationOptions;

      this.showHasEducationalEvaluation =
        this.$store.state['$_user'].user.profile.companyid == companyId &&
        disciplineTypes.includes(this.model?.disciplineTypeCod);
    },
    setShowFields() {
      this.showFields.modalities = true;
      this.showFields.frequencies = this.showFields.durations = this.showFields.intervations =
        this.model.disciplineTypeCod !==
        DisciplineTypes.EducacionFisicaAdaptada;
    },
  },
};
</script>
<style scoped></style>
